export default __webpack_public_path__ + "static/media/htb-veronica.389112ce.jpg";